import './ImpersonatedUserStyle.scss';

import PropTypes from 'prop-types';
import React from 'react';
import { Message, Spacer } from 'src/core/components';
import { getUserFullName, isCSRUser } from 'src/utils';

import messages from './messages';

const ImpersonatedUser = ({ hasRightContent }) => {
  if (!isCSRUser()) {
    return null;
  }

  const message = {
    ...messages.impersonatedUserDetails,
    values: { name: getUserFullName() },
  };

  return (
    <Spacer when={hasRightContent} right={17}>
      <div className="impersonated-user-details text-bold">
        <Message message={message} />
      </div>
    </Spacer>
  );
};

ImpersonatedUser.propTypes = {
  hasRightContent: PropTypes.bool,
};

export default ImpersonatedUser;
